import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import './auditor.css';
import AuditorForm from "./auditor-form";

function Auditor() {
    const [masterValue, setMasterValue] = useState('');
    const [masterData, setMasterData] = useState(null);
    const [view, setView] = useState('input');
    const [error, setError] = useState(''); // Estado para manejar errores

    const mockData = [
        {
          number: '111-12345678',
          type: 'directa',
          merchandiseType: 'Cont activos',
          pzas: 2,
          weight: 27.00,
          cliente: 'FedEx',
          fecha: '2025-04-10',
          origen: 'CMX',
          destino: 'GDL',
          cubiscan: 1,
          subproducts: [],
        },
        {
          number: '222-87654321',
          type: 'parcial',
          merchandiseType: 'Carga general',
          pzas: 4,
          weight: 48.30,
          cliente: 'UPS',
          fecha: '2025-04-11',
          origen: 'MTY',
          destino: 'TIJ',
          cubiscan: 1,
          subproducts: [
            { hbs: 'HBS-001', fecha: '2025-04-10', piezas: 1, peso: 5, volume: 17.89 },
            { hbs: 'HBS-002', fecha: '2025-04-11', piezas: 3, peso: 4, volume: 22.43 },
          ]
        }
    ];

    const handleInputChange = (e) => {
        let value = e.target.value; // Permitimos letras y números

        if (value.length > 3 && value[3] !== "-") {
            value = value.slice(0, 3) + "-" + value.slice(3);
        }

        setMasterValue(value);
        if (error) setError(''); // Borra el error cuando el usuario escribe
    };

    const handleSearch = () => {
        if (!masterValue.trim()) {  // Verifica si el input está vacío
            setError("Este campo es obligatorio");
            return;
        }

        const guide = mockData.find((item) => item.number === masterValue);
        if (guide && (guide.cubiscan === 1)) {
            setMasterData(guide); // guardamos todo el objeto
            setView('forms');
          } else if (guide && (guide.cubiscan === 0)) {
            Swal.fire({
                title: "Una o mas houses aún no cuentan con su validación en cubiscan",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                confirmButton: 'btn-ok',
                title: 'alert-title',
                popup: 'alert-bg'
                }
            });
          } else {
            Swal.fire({
                title: "La master no existe, por favor regístrala en el módulo de pre-captura",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                confirmButton: 'btn-ok',
                title: 'alert-title',
                popup: 'alert-bg'
                }
            });
        }
      };

    return(
        <>
            <Helmet>
                <title>Horus | Auditor</title>
            </Helmet>
            <ScrollToTop />
            <div className="container-fluid">
                {view === 'input' && (
                <div className="row justify-content-center">
                    <div className="col-6">
                        <label for="inputMaster" class="amc-label">Master</label>
                        <input 
                            type="text"
                            class="form-control"
                            id="inputMaster"
                            value={masterValue}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                        <div className="btns mt-3 d-flex justify-content-end gap-3">
                            <button className='btnn' onClick={handleSearch} >Buscar</button>
                        </div>
                    </div>
                </div>
                )}

                {view === 'forms' && <AuditorForm master={masterData} />}
                {/* {view === 'form' && <CaptureForm masterNumber={masterValue} />} */}
            </div>
        </>
    );
}

export default Auditor;